export default __webpack_public_path__ + "static/media/cosh6.d5fdce7c.jpg";